class BaseEndpoint {
  constructor(client) {
    // client.defaults.baseURL = 'http://localhost/' || '/';
    // client.defaults.withCredentials = true;

    client.$get = async function () {
      try {
        let res = await this.get(...arguments).catch(() => false)
        return (res && res.data) ? res.data :res;
      } catch (e) {
        return false
      }
    }
    client.$post = async function () {
      let res = false
      try {
        res = await this.post(...arguments)
          .catch(err => err && err.response && err.response.data ? err.response.data : err)
        return (res && res.data) ? res.data : res;
      } catch (e) {
        return e
      }
    }
    client.$delete = async function () {
      let res = false
      try {
        res = await this.delete(...arguments)
          .catch(err => err && err.response && err.response.data ? err.response.data : err)
        return (res && res.data) ? res.data : res;
      } catch (e) {
        return e
      }
    }
    this.client = client;
  }
}

export default BaseEndpoint;
